module.exports = __webpack_public_path__ + "public/Icons/siteConfiguration.svg?b6fddcc8";